import { render, staticRenderFns } from "./IconBaseDecorative.vue?vue&type=template&id=42c3e819&"
import script from "./IconBaseDecorative.vue?vue&type=script&lang=js&"
export * from "./IconBaseDecorative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports